/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SectionDeleteModalMutationVariables = {|
  id: string
|};
export type SectionDeleteModalMutationResponse = {|
  +recipeSectionDelete: ?{|
    +deleted: ?boolean
  |}
|};
export type SectionDeleteModalMutation = {|
  variables: SectionDeleteModalMutationVariables,
  response: SectionDeleteModalMutationResponse,
|};
*/


/*
mutation SectionDeleteModalMutation(
  $id: ID!
) {
  recipeSectionDelete(input: {id: $id}) {
    deleted
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RecipeDeleteSectionPayload",
    "kind": "LinkedField",
    "name": "recipeSectionDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SectionDeleteModalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SectionDeleteModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "SectionDeleteModalMutation",
    "operationKind": "mutation",
    "text": "mutation SectionDeleteModalMutation(\n  $id: ID!\n) {\n  recipeSectionDelete(input: {id: $id}) {\n    deleted\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fcccb1da0379eea8467fe686fb5da1c2';

module.exports = node;
